import { Component, inject, OnDestroy } from "@angular/core"
import { ActivatedRoute, Router } from "@angular/router"
import { Subject, Subscription } from "rxjs"
import { OrderRoutes } from "../../features/orders/orders-routes.enum"
import { EnvironmentService } from "../services/environment.service"
import { FeatureFlagService } from "../services/feature-flag.service"
import { FormValidationService } from "../services/form/form-validation.service"
import { NotificationService } from "../services/notification.service"
import { SpinnerService } from "../services/spinner.service"
import { TitleService } from "../services/title.service"
import { LaunchAuthRedirectService } from "../services/launch-auth-redirect.service"

@Component({
    template: '',
    standalone: false
})
export abstract class BaseComponent implements OnDestroy {

    protected subscriptions = new Subscription()
    protected titleService: TitleService = inject(TitleService)
    formValidationService = inject(FormValidationService)
    notificationService = inject(NotificationService)
    spinnerService = inject(SpinnerService)
    environmentService = inject(EnvironmentService)
    featureFlagService = inject(FeatureFlagService)
    protected router: Router = inject(Router)
    protected route: ActivatedRoute = inject(ActivatedRoute)
    protected destroy$ = new Subject<void>();
    protected launchAuthRedirectService = inject(LaunchAuthRedirectService)

    protected readonly orderRoutes = OrderRoutes

    /**
     *
     */
    constructor() {
    }
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe()
    }

    setTitle(title: string, subTitle?: string) {
        this.titleService.update({ title: title, subTitle: subTitle })
    }
}